import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import asyncComponent from '../components/AsyncComponent';
import { auth } from '../libs/auth';
import _ from 'lodash';
import { setTitle } from '../utils/misc';

const NotAllowed = asyncComponent(() => import('../containers/NotAllowed'));

export default ({ component: C, props: cProps, groups, title, highlight, ...rest }) => {
  setTitle(title);
  return (
    <Route
      {...rest}
      render={props => {
        if (!auth.getUserToken()) {
          return (
            <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`} />
          );
        }

        if (groups && groups.length && !_.intersection(groups, cProps.store.user.groups).length) {
          return <NotAllowed />;
        }

        return (
          <Row>
            <Col xs={12} className={highlight ? `${highlight} pb-20` : ''}>
              <C {...props} {...cProps} />
            </Col>
          </Row>
        );
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/AuthenticatedRoute.js